import React, { Component } from "react";
import PropTypes from "prop-types";

export default class OutsideClickCloseDropDown extends Component {
	constructor(props) {
		super(props);

		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClickOutside(e) {
		const { setIsOpen } = this.props;

		if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
			setIsOpen(false);
		}
	}

	render() {
		return <div ref={this.setWrapperRef} className={this.props.className}>{this.props.children}</div>;
	}
}

OutsideClickCloseDropDown.propTypes = {
	children: PropTypes.element.isRequired,
};
